import { FC } from 'react'
import { ContactAddressType } from '../../../../../../common/ContactAddress.type'
import userRole from '../../../../../../config/userRole'
import { useProcessContactAddress } from '../../../../../../hooks/fetch/contactAddress/useProcessContactAddress'
import useContactAddressCard from '../../../../../../hooks/useContactAddressCard'
import { fullName } from '../../../../../../util/fullName'
import DeleteButton from '../../../../../UtilComponent/level_1/DeleteButton'
import EditButton from '../../../../../UtilComponent/level_1/EditButton'
import FavoriteButton from './FavoriteButton'

type Props = {
  contactAddress: ContactAddressType
}

const CardProcessIcons: FC<Props> = (props) => {
  const { contactAddress } = props

  const { role } = useContactAddressCard(contactAddress)

  const { deleContactAddress } = useProcessContactAddress()

  return (
    <div className="cluster mx-4">
      {contactAddress.category === 'shared' && role === userRole["一般ユーザー"] ? (
        <FavoriteButton contactAddress={contactAddress} />
      ) : (
        <span className="ms-4"></span>
      )}

      {(role === userRole['カンパニー管理者'] ||
        contactAddress.category === 'personal') && (
        <>
          <EditButton linkPath={`/contactAddress/${contactAddress.id}/edit`} />
          <DeleteButton
            id={contactAddress.id}
            name={fullName(contactAddress)}
            removeAPIMethod={deleContactAddress}
          />
        </>
      )}
    </div>
  )
}

export default CardProcessIcons
